import { useNavigate } from "react-router-dom";

const CallToActionSection = () => {
  const navigate = useNavigate();
  return (
    <section className="text-center mb-16">
      <div className="bg-gradient-to-r from-yellow-400 to-orange-500 rounded-2xl p-12 text-white">
        <h2 className="text-4xl font-black mb-4">Ready to Game?</h2>
        <p className="text-xl mb-8 text-orange-100">
          Join thousands of gamers who trust GamesHub for their gaming needs
        </p>
        <div className="flex justify-center space-x-4">
          <button
            onClick={() => navigate("/products")}
            className="bg-white text-orange-600 px-8 py-4 rounded-lg font-bold text-lg hover:bg-gray-50 hover:shadow-lg transition duration-300 transform hover:scale-105"
          >
            View All Products
          </button>
          <button
            onClick={() => navigate("/about")}
            className="bg-transparent border-2 border-white text-white px-8 py-4 rounded-lg font-bold text-lg hover:bg-white hover:text-orange-600 transition duration-300"
          >
            Learn More
          </button>
        </div>
      </div>
    </section>
  );
};

export default CallToActionSection;
